import { BaseControl, ControlPosition } from "./BaseControl.js";
import { Pano } from "../Pano.js";

export class ControlTrack extends BaseControl {
    private _trackProgress: HTMLDivElement;
    private _trackTime: HTMLDivElement;
    private _thumb: HTMLDivElement;
    private _isDragging: boolean = false;

    constructor(pano: Pano) {
        super(pano, ControlPosition.TOP);

        this.element.classList.add("control-track");
        this.element.innerHTML = `
            <div class="control-track-background"></div>
            <div class="control-track-progress"></div>
            <div class="control-track-time">
                <div class="control-track-thumb"></div>
            </div>
        `;
        this._trackProgress = this.element.querySelector(".control-track-progress");
        this._trackTime = this.element.querySelector(".control-track-time");
        this._thumb = this.element.querySelector(".control-track-thumb");

        this.pano.video.addEventListener("progress", (e) => this.updateProgress());
        this.pano.video.addEventListener("timeupdate", (e) => this.updateTime());
        this.pano.onChangeVideo.add(() => this.reset());

        this.updateProgress();

        var px:number = 0;
        var startDrag = (pageX: number, pageY: number): void => {
            this._isDragging = true;
            this._thumb.classList.add("active");
            drag(pageX, pageY);
        };
        var drag = (pageX: number, pageY: number): void => {
            var bounds = this.element.getBoundingClientRect();
            var ratio = e5.Calc.clamp((pageX - bounds.left) / bounds.width, 0, 1);
            px = pageX;
            this._trackTime.style.width = (ratio * 100).toPrecision(6) + "%";
        };
        var endDrag = (): void => {
            this._isDragging = false;
            this._thumb.classList.remove("active");
            this.seek(px);
            document.removeEventListener("touchmove", onTouchMove);
            document.removeEventListener("touchend", onTouchEnd);
            document.removeEventListener("touchcancel", onTouchEnd);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
        };

        var onTouchMove = (e:TouchEvent) => drag(e.touches[0].pageX, e.touches[0].pageY);
        var onTouchEnd = (e:TouchEvent) => endDrag();
        this.element.addEventListener("touchstart", (e) => {
            startDrag(e.touches[0].pageX, e.touches[0].pageY);
            document.addEventListener("touchmove", onTouchMove);
            document.addEventListener("touchend", onTouchEnd);
            document.addEventListener("touchcancel", onTouchEnd);
        });

        var onMouseMove = (e:MouseEvent) => drag(e.pageX, e.pageY);
        var onMouseUp = (e:MouseEvent) => endDrag();
        this.element.addEventListener("mousedown", (e) => {
            startDrag(e.pageX, e.pageY);
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
        });
    }

    private reset(): void {
        this._trackTime.style.width = "0%";
        this._trackProgress.style.width = "0%";
        this.updateTime();
    }

    private seek(pageX: number): void {
        var bounds = this.element.getBoundingClientRect();
        var ratio = (pageX - bounds.left) / bounds.width;
        this.pano.video.currentTime = ratio * this.pano.video.duration;
        this._trackTime.style.width = (ratio * 100).toPrecision(6) + "%";
    }

    private updateTime(): void {
        if (this._isDragging)
            return;
        var ratio = this.pano.video.currentTime / this.pano.video.duration;
        this._trackTime.style.width = (ratio * 100).toPrecision(6) + "%";
        this.updateProgress();
    }

    private updateProgress(): void {
        if (this.pano.video.buffered.length === 0) {
            this._trackProgress.style.width = "0";
            return;
        }
        var ratio = this.pano.video.buffered.end(0) / this.pano.video.duration;
        this._trackProgress.style.width = (ratio * 100).toPrecision(6) + "%";
    }
}